<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    Labels: Array,
    DataSet: Array,
  },
  mounted() {
    this.renderChart(
      {
        labels: this.Labels,
        datasets: this.DataSet,
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: -40,
            bottom: 0,
          },
        },
        scales: {
          // The following will affect the vertical lines (xAxe) of your dataset
          xAxes: [
            {
              gridLines: {
                // You can change the color, the dash effect, the main axe color, etc.
                display: false,
              },
            },
          ],

          // And this will affect the horizontal lines (yAxe) of your dataset
          yAxes: [
            {
              gridLines: {
                borderDash: [8, 4],
                color: "#CFD8DC",
              },
            },
          ],
        },

        title: {
          display: true,
        },
      }
    );
  },
};
</script>